"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOnePairOfEyes = void 0;
const Meld_1 = require("./Meld");
const MeldType_1 = require("./MeldType");
/**
 * (Chinese: 做眼) Form the Meld consisting of two identical Tiles.
 * @param inputTiles array of Tiles.
 * @returns the Eyes formed.  Null if the Tiles array is unable to form the Eyes.
 */
function eyes(inputTiles) {
    const copyOfInputTiles = inputTiles.slice();
    for (let i = 0; i < copyOfInputTiles.length; i++) {
        for (let j = 0; j < copyOfInputTiles.length; j++) {
            if (i !== j && copyOfInputTiles[i].isIdentical(copyOfInputTiles[j])) {
                return new Meld_1.default([copyOfInputTiles[i], copyOfInputTiles[j]]);
            }
        }
    }
    return null;
}
exports.default = eyes;
function hasOnePairOfEyes(inputMelds) {
    let numberOfPairOfEyes = 0;
    for (const meld of inputMelds) {
        if (meld.getMeldType() === MeldType_1.MeldType.EYES) {
            numberOfPairOfEyes++;
        }
    }
    return numberOfPairOfEyes === 1;
}
exports.hasOnePairOfEyes = hasOnePairOfEyes;
